import { SxProps } from '@mui/system';
import { MyTheme } from 'src/theme';

export const dosageActionStyles: SxProps = {
  display: 'flex',
  justifyContent: 'flex-end',
};

export const dosageSectionStyles: SxProps<MyTheme> = {
  paddingBottom: 7,
};

export const sectionHeadingStyles: SxProps<MyTheme> = {
  h2: {
    paddingBottom: 2,
  },
  paddingBottom: 4,
};
